import { gql } from '@apollo/client';

export const typeOptions = [
  { value: 'Hearing', label: 'Hearing' },
  { value: 'Procedural', label: 'Procedural' },
];

export const resultOptions = [
  { value: 'Granted', label: 'Granted' },
  { value: 'Denied', label: 'Denied' },
];

export const GET_ALL_APPEALS = gql`
  query Appeals($input: String) {
    appeals(input: $input) {
      data {
        id
        proceedingId
        participantId
        type
        requestDate
        resultDate
        result
        decision
        decisionDate
        comments
        decisionOutcome
        panelConditions
      }
    }
  }
`;

export const DELETE_APPEAL = gql`
  mutation DeleteAppeal($input: AppealQuery) {
    deleteAppeal(input: $input) {
      result
    }
  }
`;

export const ADD_NEW_APPEAL = gql`
  mutation AddAppeal($input: Appeal) {
    addAppeal(input: $input) {
      result
    }
  }
`;

export const UPDATE_APPEAL = gql`
  mutation UpdateAppeal($input: UpdateAppealDetails) {
    updateAppeal(input: $input) {
      result
    }
  }
`;

export const GET_APPEAL = gql`
  query appeal($input: AppealQuery) {
    appeal(input: $input) {
      id
      proceedingId
      participantId
      type
      requestDate
      resultDate
      result
      decision
      decisionDate
      comments
      decisionOutcome
      panelConditions
    }
  }
`;

export const SEARCH_MEMBERS = gql`
  query SearchMembers($input: String!) {
    searchMembers(input: $input) {
      id
      displayName
      firstName
      lastName
      phoneNumber
      email
    }
  }
`;

export const SEARCH_EMPLOYEE = gql`
  query SearchEmployee($input: String!) {
    searchEmployee(input: $input) {
      id
      displayName
      firstName
      lastName
      phoneNumber
      email
    }
  }
`;

export const GET_PARTICIPANTS = gql`
  query GetParticipants($input: ParticipantsQuery) {
    participants(input: $input) {
      data {
        id
        proceedingId
        receiptRequestDate
        decisionIssueDate
        contactName
        applicantBaId
        partyName
        type
        otherParticipantTypeDescription
        phoneNumber
        email
        comments
        allowDelete
        isPrimaryContact
      }
    }
  }
`;

export const DELETE_PARTICIPANT = gql`
  mutation DeleteParticipant($input: ParticipantQuery) {
    deleteParticipant(input: $input) {
      result
    }
  }
`;

export const GET_PARTICIPANT = gql`
  query GetParticipantDetail($input: ParticipantQuery) {
    participant(input: $input) {
      receiptRequestDate
      decisionIssueDate
      firstName
      lastName
      applicantBaId
      applicantName
      displayName
      type
      otherParticipantTypeDescription
      phoneNumber
      email
      comments
      id
      proceedingId
    }
  }
`;

export const GET_PROCEEDINGS_QUERY = gql`
  query Proceedings($filter: ProceedingsFilterInput) {
    proceedings(filter: $filter) {
      data {
        chcReceivedDate
        id
        proceedingId
        location
        isJoint
        referralDate
        status
      }
    }
  }
`;

export const GET_UNIQUE_PARTIES = gql`
  query UniqueParties($input: String) {
    uniqueParties(input: $input) {
      partyName
      participantId
    }
  }
`;
